import { type FrontendConfigurationSchema } from '../../generated/frontend';

/**
 * Gets `window.doxymeconfig.frontend` (assuming client-side)
 * @returns FrontendConfigurationSchema from `doxymeconfig.frontend`
 */
export const getFrontendConfigs = (): FrontendConfigurationSchema | undefined =>
  window.doxymeconfig?.frontend;
